// Die Rückfrage vor einer Handlung, die sich nicht zurücknehmen lässt:
// Konto löschen, Vorlage entfernen, API-Schlüssel widerrufen, Sammlung
// löschen, Sperrlisten-Eintrag löschen.
//
// Warum das hier steht und nicht als `onsubmit`-Attribut am Formular: seit
// der Content-Security-Policy (config/initializers/content_security_policy.rb)
// führt der Browser keinen Inline-Handler mehr aus -- `script-src` kennt kein
// 'unsafe-inline', und genau das ist der Punkt der Richtlinie. Ein
// `onsubmit="return confirm(…)"` wäre stillschweigend wirkungslos, und die
// Löschung liefe beim ersten Klick durch. (Das war sie einmal schon, bevor die
// Handler eingeführt wurden: `data: { confirm: }` von rails-ujs und
// `data-turbo-confirm` von Turbo sind hier wirkungslos, weil weder das eine
// noch das andere geladen ist.)
//
// Ein einziger Zuhörer am Dokument statt einer je Formular: Formulare, die
// erst später in die Seite kommen (ein React-Dialog, ein nachgeladener
// Abschnitt), sind damit von selbst mitgemeint. In der Capture-Phase, damit
// die Absage vor jedem anderen Submit-Zuhörer steht.

export const CONFIRM_ATTRIBUTE = 'data-confirm'

/**
 * Die Frage, die dieses Formular stellen soll -- oder null, wenn es keine
 * stellt. Exportiert, damit sich die eine Regel ohne DOM prüfen lässt.
 */
export function confirmMessage(form: { getAttribute(name: string): string | null }): string | null {
  const message = form.getAttribute(CONFIRM_ATTRIBUTE)
  return message ? message : null
}

export function startConfirmForms(
  root: Document = document,
  ask: (message: string) => boolean = (message) => window.confirm(message),
): void {
  root.addEventListener(
    'submit',
    (event) => {
      const form = event.target
      if (!(form instanceof HTMLFormElement)) return

      const message = confirmMessage(form)
      if (message === null) return
      if (!ask(message)) event.preventDefault()
    },
    true,
  )
}
